"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "formatNumber", {
  enumerable: true,
  get: function get() {
    return _formatNumber.default;
  }
});
Object.defineProperty(exports, "formatPhoneNumber", {
  enumerable: true,
  get: function get() {
    return _formatPhoneNumber.default;
  }
});
Object.defineProperty(exports, "formatSSN", {
  enumerable: true,
  get: function get() {
    return _formatSSN.default;
  }
});
Object.defineProperty(exports, "formatState", {
  enumerable: true,
  get: function get() {
    return _formatState.default;
  }
});
Object.defineProperty(exports, "numberShortener", {
  enumerable: true,
  get: function get() {
    return _numberShortener.default;
  }
});
Object.defineProperty(exports, "toNumber", {
  enumerable: true,
  get: function get() {
    return _toNumber.default;
  }
});
Object.defineProperty(exports, "toKabobCase", {
  enumerable: true,
  get: function get() {
    return _toKabobCase.default;
  }
});
Object.defineProperty(exports, "toTitleCase", {
  enumerable: true,
  get: function get() {
    return _toTitleCase.default;
  }
});
Object.defineProperty(exports, "toUpperCase", {
  enumerable: true,
  get: function get() {
    return _toUpperCase.default;
  }
});
exports.default = void 0;

var _formatNumber = _interopRequireDefault(require("./formatNumber"));

var _formatPhoneNumber = _interopRequireDefault(require("./formatPhoneNumber"));

var _formatSSN = _interopRequireDefault(require("./formatSSN"));

var _formatState = _interopRequireDefault(require("./formatState"));

var _numberShortener = _interopRequireDefault(require("./numberShortener"));

var _toNumber = _interopRequireDefault(require("./toNumber"));

var _toKabobCase = _interopRequireDefault(require("./toKabobCase"));

var _toTitleCase = _interopRequireDefault(require("./toTitleCase"));

var _toUpperCase = _interopRequireDefault(require("./toUpperCase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-multi-spaces */
// this is to make use within alex easier
// this is to support exposing these functions in the build
var _default = {
  formatNumber: _formatNumber.default,
  formatPhoneNumber: _formatPhoneNumber.default,
  formatSSN: _formatSSN.default,
  formatState: _formatState.default,
  numberShortener: _numberShortener.default,
  toNumber: _toNumber.default,
  toKabobCase: _toKabobCase.default,
  toTitleCase: _toTitleCase.default,
  toUpperCase: _toUpperCase.default
};
exports.default = _default;